module.exports = __webpack_public_path__ + "img/quan.0cc83195.png";